/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Directory_Vibebids_Claim_ForInputs */

const en_directory_vibebids_claim_for = /** @type {(inputs: Directory_Vibebids_Claim_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`claim for $${i?.amount}`)
};

const zh_directory_vibebids_claim_for = /** @type {(inputs: Directory_Vibebids_Claim_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`以 $${i?.amount} 抢占`)
};

/**
* | output |
* | --- |
* | "claim for ${amount}" |
*
* @param {Directory_Vibebids_Claim_ForInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_claim_for = /** @type {((inputs: Directory_Vibebids_Claim_ForInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Claim_ForInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_claim_for(inputs)
	return zh_directory_vibebids_claim_for(inputs)
});
export { directory_vibebids_claim_for as "directory.vibebids.claim_for" }